"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const vuex_1 = require("vuex");
exports.default = vue_1.default.extend({
    name: 'app-header',
    computed: Object.assign({}, vuex_1.mapGetters('user', [
        'user'
    ]), { isLogin: function () {
            return this.$route.name === 'login';
        }, isSettings: function () {
            return this.$route.name === 'settings';
        } }),
    methods: {}
});
